var _defs, _style, _use, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirtel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 50",
    width: 90,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 50,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAyAQMAAADmwV52AAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA9JREFUeJxjYBgFo2AwAAACigABxXWI+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 76,
    height: 48,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiBpY29uLS1mdWxsLWNvbG9yIiB2aWV3Qm94PSIwIDAgMzggMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgaGVpZ2h0PSIyNCIgd2lkdGg9IjM4IiByb2xlPSJpbWciIGFyaWEtbGFiZWxsZWRieT0icGktYWlydGVsX21vbmV5Ij48dGl0bGUgaWQ9InBpLWFpcnRlbF9tb25leSI+QWlydGVsIE1vbmV5PC90aXRsZT48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik0zNC41IDI0aC0zMUMxLjYgMjQgMCAyMi40IDAgMjAuNXYtMTdDMCAxLjYgMS42IDAgMy41IDBoMzFDMzYuNCAwIDM4IDEuNiAzOCAzLjV2MTdjMCAxLjktMS42IDMuNS0zLjUgMy41eiIvPjxwYXRoIGQ9Ik0zLjUgMUMyLjEgMSAxIDIuMSAxIDMuNXYxN0MxIDIxLjkgMi4xIDIzIDMuNSAyM2gzMWMxLjQgMCAyLjUtMS4xIDIuNS0yLjV2LTE3QzM3IDIuMSAzNS45IDEgMzQuNSAxaC0zMXoiLz48cGF0aCBmaWxsPSIjRUIyMjI3IiBkPSJNMjIuMyAzYy42LjEgMS4yLjIgMS43LjMgMi4yLjQgMy45IDIgNC41IDQuMS4zIDEuNi4xIDMuMy0uNyA0LjctLjkgMS44LTIuMSAzLjMtMy43IDQuNS0yLjEgMS44LTQuNiAzLjItNy4zIDQuMS0uNi4yLTEuMy4zLTEuOS4zLTEuMS4xLTIuMS0uNy0yLjItMS44di0uNWMuMi0yLjEgMS43LTMuOCAzLjgtNC40LjUgMCAxIDAgMS40LjIuNS4yLjguOC42IDEuNC0uMS4yLS4yLjMtLjMuNC0uNC40LS44LjgtMS4yIDEuMXMtLjcuNi0xIDFjLS4yLjItLjMuNC0uNC42LS4yLjQgMCAuNi40LjYuMiAwIC40IDAgLjYtLjEgMy41LTEuMyA2LjMtMy43IDguMS02LjkuMy0uNS40LTEgLjQtMS42LjEtMS43LTEtMi43LTIuNi0yLjItMS4yLjQtMi41LjktMy42IDEuNS0xLjIuNi0yLjQgMS40LTMuNiAyLS45LjUtMS45LjgtMyAuOS0uNS4xLTEgMC0xLjQtLjEtMS0uMS0xLjgtMS4xLTEuNi0yLjMgMC0uMSAwLS4yLjEtLjMuNS0xLjQgMS40LTIuNyAyLjYtMy41IDIuMy0xLjggNS0zLjEgNy45LTMuNy41LS4xIDEuMS0uMiAxLjYtLjNoLjh6Ii8+PC9nPjwvc3ZnPg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    transform: "matrix(.929,0,0,.929,8.71,1.712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtel);
export default __webpack_public_path__ + "static/media/airtel.8997a1994800ec5a36768902568432e2.svg";
export { ForwardRef as ReactComponent };